import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    partners: {
        currentTab: null,
        currentTabMeta: null
    }
}

export const pageAboutSlice = createSlice({
    name: 'pageAbout',
    initialState,
    reducers: {
        setCurrentTab: (state, action) => {
            state.partners.currentTab = action.payload.currentTab;
            state.partners.currentTabMeta = action.payload.currentTabMeta;
        }
    }
});

export const {setCurrentTab} = pageAboutSlice.actions;

export default pageAboutSlice.reducer;